import React, { createContext, useContext } from 'react';

const KataBoardCanEditContext = createContext(true);

export const useKataBoardCanEdit = (): boolean => useContext(KataBoardCanEditContext);

interface KataBoardAccessProviderProps {
  canEdit: boolean;
  children: React.ReactNode;
}

export const KataBoardAccessProvider: React.FC<KataBoardAccessProviderProps> = ({
  canEdit,
  children,
}) => (
  <KataBoardCanEditContext.Provider value={canEdit}>
    {children}
  </KataBoardCanEditContext.Provider>
);
